let lowerTooltip = null;
export const getLowerTooltipRoot = () => {
  if (lowerTooltip === null) {
    lowerTooltip = document.getElementById("lower-tooltip-root");
  }
  return lowerTooltip;
};
